var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnCheckedRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "#0D0D0D",
    strokeWidth: 1.1375
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.1375
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.1375
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.1375
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.1375
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.56875,
    y: 0.56875,
    width: 26.8625,
    height: 26.8625,
    rx: 13.4312,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.1375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCheckedRadio);
export default __webpack_public_path__ + "static/media/UnCheckedRadio.8a66b39e094738b8ba415b00c1dccb52.svg";
export { ForwardRef as ReactComponent };